import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './SolicitudCorrectivoArea.css';

import TextField from '@material-ui/core/TextField';
import MyButton from '../../../utils/MyButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import CircularProgress from '@material-ui/core/CircularProgress';

import { FaArrowLeft, FaPlus, FaCogs, FaCheck } from "react-icons/fa";

import { 
    postSolicitudMtoInfra, 
    getSolicitudesCorrInfra,
    clearErrors
} from '../../../redux/actions/infraactions';

import {
    getUsuariosAsistenciales
} from '../../../redux/actions/useractions';

export class SolicitudCorrectivoArea extends Component {
    constructor(){
        super();
        this.state = {
            infosolicitud: '',
            usuarioAsistencialId: '',
            errors: {},
            open: false,
            aprobado: {}
        };
    }

    static getDerivedStateFromProps(props, state) {
        const newState = {};
    
        if (props.UI.errors) {
            newState.errors = props.UI.errors;
        }
    
        if (props.UI.aprobado) {
            newState.aprobado = props.UI.aprobado;
        }
    
        return Object.keys(newState).length > 0 ? newState : null;
    }

    componentDidMount() {
        if(this.state.open) {
            this.props.getUsuariosAsistenciales(this.props.clienteId);
        }
    }

    handleOpen = () => {
        this.setState({open: true});
        this.props.getUsuariosAsistenciales(this.props.clienteId);
    };

    handleClose = () => {
        if (this.state.aprobado.message) {
            this.props.getSolicitudesCorrInfra(this.props.areaId);            
            this.setState({
                open: false,
                errors: {},
                infosolicitud: '',
                usuarioAsistencialId: '',
                aprobado: {}
            });
            this.props.clearErrors();
        } else {
            this.props.clearErrors();
            this.setState({
                open: false,
                errors: {},
                infosolicitud: '',
                usuarioAsistencialId: '',
                aprobado: {}
            });
        }
    };
    
    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const fechasolicitud = Date.now();
        
        if (!this.state.infosolicitud || !this.state.usuarioAsistencialId) {
            this.setState({
                errors: {
                    infosolicitud: !this.state.infosolicitud ? 'Este campo es requerido' : '',
                    usuarioAsistencialId: !this.state.usuarioAsistencialId ? 'Debe seleccionar un usuario asistencial' : ''
                }
            });
            return;
        }

        // Encontrar el usuario asistencial seleccionado
        const usuarioAsistencial = this.props.usuariosAsistenciales.find(
            usuario => usuario.idUsuario === this.state.usuarioAsistencialId
        );
/**
 * 
 * piso(pin):1
ubicacion(pin):"Edificio 1"
servicio(pin):"Consulta Externa"
clienteId(pin):"vRXa6GZHJDIKjw6mFKAS"
 */
        const newSolicitudMto = {
            infosolicitud: this.state.infosolicitud,
            idprestador: this.props.area.clienteId,
            idusersolicita: usuarioAsistencial.userId,
            handlesolicita: usuarioAsistencial.handle,
            nombresolicita: usuarioAsistencial.nombre,
            nombrearea: this.props.area.nombre,
            piso:this.props.area.piso,
            ubicacion:this.props.area.ubicacion,
            servicio:this.props.area.servicio,
            handleuser: this.props.area.userhandle,
            areaid: this.props.areaId,
            fechasolicitudmilis: fechasolicitud,
            telnotificacion: this.props.user.credentials.telefono,
            emailnotificacion: this.props.user.credentials.email,
            usuarioAsistencialId: this.state.usuarioAsistencialId
        };
        console.log(newSolicitudMto);
        this.props.postSolicitudMtoInfra(newSolicitudMto, this.props.areaId);
    }

    render() {
        const { UI: { loading }, usuariosAsistenciales } = this.props;
        const { errors } = this.state;

        return (
            <div>
                <Fragment>
                    <MyButton tip="Solicitar Mantenimiento Correctivo" onClick={this.handleOpen}>
                        <FaCogs color="#03178C" className="icon-crearcliente"/>
                    </MyButton>

                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        fullWidth
                        maxWidth="sm"
                    >
                        {this.state.aprobado.message ? 
                            (<></>) : 
                            (<DialogTitle>Solicitar Mantenimiento Correctivo</DialogTitle>)
                        }

                        <DialogContent>
                            {this.state.aprobado.message? (
                                <div className='div-aprobado'>
                                    <div className='div-icono-aprobado'>
                                        <FaCheck color="#ffffff" className='icono-aprobado' />
                                    </div>
                                    <h2 className='text-aprobado'>{this.state.aprobado.message}</h2>
                                </div>
                            ) : (
                                <form>
                                    <TextField
                                        className="login-input-email"
                                        required
                                        type="text"
                                        name="infosolicitud"
                                        id="infosolicitud"
                                        label="Ingresa tu Solicitud"
                                        value={this.state.infosolicitud}
                                        onChange={this.handleChange}
                                        fullWidth
                                        helperText={errors.infosolicitud}
                                        error={errors.infosolicitud ? true : false}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />

                                    <FormControl fullWidth margin="normal">
                                        <InputLabel id="usuario-asistencial-label">
                                            Usuario Asistencial
                                        </InputLabel>
                                        <Select
                                            labelId="usuario-asistencial-label"
                                            id="usuarioAsistencialId"
                                            name="usuarioAsistencialId"
                                            value={this.state.usuarioAsistencialId}
                                            onChange={this.handleChange}
                                            error={errors.usuarioAsistencialId ? true : false}
                                        >
                                            {usuariosAsistenciales && usuariosAsistenciales.map((usuario) => (
                                                <MenuItem key={usuario.idUsuario} value={usuario.idUsuario}>
                                                    {usuario.nombre}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </form>
                            )}
                        </DialogContent>

                        <DialogActions>
                            <MyButton tip="Cerrar" onClick={this.handleClose}>
                                <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
                            </MyButton>

                            {loading ? (
                                <CircularProgress size={30} color="primary" className="login-progress" />
                            ) : this.state.aprobado.message ? (
                                <></>
                            ) : (
                                <MyButton tip="Solicitar Mantenimiento Correctivo" onClick={this.handleSubmit}>
                                    <FaPlus color="#03178C" className="icon-formulario"/>
                                </MyButton>
                            )}
                        </DialogActions>
                    </Dialog>
                </Fragment>
            </div>
        )
    }
}

SolicitudCorrectivoArea.propTypes = {
    postSolicitudMtoInfra: PropTypes.func.isRequired,
    getSolicitudesCorrInfra:PropTypes.func.isRequired,
    getUsuariosAsistenciales: PropTypes.func.isRequired,
    clearErrors: PropTypes.func.isRequired,
    UI: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
   
    usuariosAsistenciales: PropTypes.array.isRequired,
    clienteId: PropTypes.string.isRequired,
   
};

const mapStateToProps = (state) => ({
    UI: state.UI,
    user: state.user,
    area: state.datainfra.area.credentials,
    data: state.data,
    usuariosAsistenciales: state.user.usuariosAsistenciales || []
});

export default connect(
    mapStateToProps,
    { postSolicitudMtoInfra, clearErrors, getUsuariosAsistenciales,getSolicitudesCorrInfra }
)(SolicitudCorrectivoArea);